var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 27,
  height: 27,
  viewBox: "0 0 27 27"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "Rectangle_295",
  x: 0,
  y: 0,
  width: 27,
  height: 27,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 1,
  input: "SourceAlpha"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5,
  result: "blur"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.329
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "blur"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_2200",
  "data-name": "Group 2200",
  transform: "translate(-737.5 415.5)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2174",
  "data-name": "Group 2174",
  transform: "translate(218 -1110)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2154",
  "data-name": "Group 2154"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1, 0, 0, 1, 519.5, 694.5)",
  filter: "url(#Rectangle_295)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_295-2",
  "data-name": "Rectangle 295",
  width: 24,
  height: 24,
  rx: 12,
  transform: "translate(1.5 0.5)",
  fill: "#cd86ed"
})), /*#__PURE__*/React.createElement("g", {
  id: "play-button-arrowhead",
  transform: "translate(528.266 700.492)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_32",
  "data-name": "Path 32",
  d: "M10.04.276C8.972-.371,8.107.159,8.107,1.458v9.59c0,1.3.865,1.83,1.933,1.184l7.935-4.807a1.257,1.257,0,0,0,0-2.342Z",
  transform: "translate(-8.107 0)",
  fill: "#fff"
}))), /*#__PURE__*/React.createElement("g", {
  id: "play-button-arrowhead-2",
  "data-name": "play-button-arrowhead",
  transform: "translate(529.163 702.171)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_32-2",
  "data-name": "Path 32",
  d: "M9.7.208C8.819-.28,8.107.12,8.107,1.1V8.325c0,.98.712,1.379,1.589.892L16.22,5.595c.878-.488.878-1.277,0-1.765Z",
  transform: "translate(-8.107 0)",
  fill: "#b715ff"
}))))));
export default __webpack_public_path__ + "static/media/video-active.2baaffff.svg";
export { SvgComponent as ReactComponent };